import TipManagerCheckoutDrawer from './TipManagerCheckoutDrawer';
export default TipManagerCheckoutDrawer;
